export default __webpack_public_path__ + "static/PC_bg_02-e3b5c3d414479a01cbf30a2ec54009c6.png";